import styled from "styled-components";
import React, {useEffect, useState} from "react";
import {useInterval} from "react-interval-hook";
import {API} from "../../../../api";
import {AnimatePresence, motion} from "framer-motion";

const SBackground = styled.div`
    position: absolute;
    width: 100dvw;
    height: 100dvh;
    
    #background-content {
        background-repeat: no-repeat;
        background-size: cover;
        width: calc(100dvw + 280px);
        height:  calc(100dvh + 280px);
        top: -140px;
        left: -140px;
        opacity: 0.7;
        background-position: center;
        position: fixed;
    }
    
    #video {
      position: fixed;
      right: 0;
      bottom: 0;
      min-width: 100dvw;
      min-height: 100dvh;
      opacity: 0;
      filter: brightness(1);
      transition: 0.7s opacity, 0.7s filter;
    }
    
`;

const convertUrl = (url) => {
    const url_no_protocol = url.trim("https://");
    let subdomain = url_no_protocol.split('.')[0];
    let path = "/".join(url_no_protocol.split("/").slice(1));
    return `https://klzmmusicmanager.ru/video/${subdomain}/${path}`;
}

const api = new API();


export function Background({trackInfo, setHasVideo, hasVideo, currentTime, playerPaused, weakConnection, hasLyrics, isPaused, videoQuality}) {
    const [videoUrl, setVideoUrl] = useState(null);
    const [handledUrl, setHandledUrl] = useState(null);
    const qualities = [480, 720, 1080];

    const handleRedirects = (url) => {
        return new Promise((resolve, reject) => {
            if (!url || !url.startsWith("https:")) {
                resolve(url);
                return;
            }
            api.handleVideoUrl(url).then((res) => {
                console.log("resss", res);
                resolve(res.url);
            })
        })


    };

    const parseVideoUrls = () => {
        if (videoQuality === "disabled") return;
        if (!trackInfo.video) return;
        let all_q;
        try {
            all_q = JSON.parse(trackInfo.video);
        } catch (e) {
            return trackInfo.video;
        }

        if (!all_q) return trackInfo.video;

        let last_url = null;
        for (const q of qualities) {
            if (q > parseInt(videoQuality)) break;
            if (!all_q[q]) continue;
            last_url = all_q[q][0].url;
        }
        return last_url;
    };

    useEffect(() => {

    }, [videoQuality]);

    const handleResize = () => {
        let v = document.getElementById("video");
        if (v) {
            let w = window.innerWidth;
            let h = window.innerHeight;
            let vw = v.getBoundingClientRect().width;
            let vh = v.getBoundingClientRect().height;
            v.style.bottom = ((h - vh) / 2) +  "px";
            v.style.right = ((w - vw) / 2) +  "px";
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);

    useEffect(() => {
        let v = document.getElementById("video");
        console.log("opacity fired", hasLyrics, hasVideo, v);
        if (v && hasLyrics && v.style.filter === "brightness(0.9)") {
            v.style.filter = "brightness(0.7)";
        } else if (v && !hasLyrics && v.style.filter === "brightness(0.7)") {
            v.style.filter = "brightness(0.9)";
        }
    }, [hasLyrics, hasVideo]);

    useEffect(() => {
        const video = document.getElementById("video");
        if (video) {
            if (video.paused && !playerPaused) video.play();
            if (!video.paused && playerPaused) video.pause();
        }
    }, [playerPaused]);

    useInterval(() => {
        const video = document.getElementById("video");
        if (video) {
            if (currentTime > video.duration * 1000 && currentTime > 5000) {
                removeVideo();
            }
            if (video.paused) return;
            if (Math.abs((video.currentTime * 1000) - currentTime) > 200) {
                const v = document.getElementById("video");
                if (v.getAttribute("seeking_allowed") !== "no") {
                    v.currentTime = currentTime / 1000;
                    v.setAttribute("seeking_allowed", "no");
                }

            }
        }

    }, 300);

    const removeVideo = () => {
        return new Promise((resolve, reject) => {
            try {
                document.getElementById("video").style.opacity = 0;
                setTimeout(() => {
                    try {
                        document.getElementById("video").remove();
                    } catch (e) {
                    }
                    resolve();
                }, 700);
                setHasVideo(false);

            } catch (e) {
                resolve();
                setHasVideo(false);
            }
        });

    };

    function compareVideo() {
        return new Promise((resolve, reject) => {
            let video = document.getElementById("video");
            let w = video.videoWidth;
            let h = video.videoHeight;
            if (w === h) reject();
            else resolve();
        });

    }

    useEffect(() => {
        const url = parseVideoUrls();
        if (url !== videoUrl) {
            setVideoUrl(url);
            setHandledUrl(null);
            handleRedirects(url).then((u) => {

                setHandledUrl(u);
            });
        }
    }, [trackInfo, videoQuality]);

    useEffect(() => {
        if (handledUrl && !weakConnection) {
            console.log("upd");
            removeVideo().then(() => {
                const v = document.createElement("video");
                v.style.opacity = "0";
                let s = document.createElement("source");
                s.id = "source";
                v.id = "video";
                s.src = handledUrl;
                v.preload = "auto";
                v.muted = true;
                v.addEventListener("loadeddata", function() {
                    v.play();
                    setTimeout(() => {
                        compareVideo().then(() => {
                            v.style.filter = hasLyrics ? "brightness(0.7)" : "brightness(0.9)";
                            v.style.opacity = "1";
                            setHasVideo(true);
                            handleResize();
                        }).catch(() => {
                            removeVideo();
                        });
                    }, 500);
                }, false);
                v.addEventListener("play", (event) => {
                    console.error(
                        "play pressed"
                    );
                });
                v.addEventListener("playing", (event) => {
                    console.error(
                        "playing started"
                    );
                });
                v.addEventListener("canplay", (event) => {
                    console.error("canplay");
                });
                v.addEventListener("canplaythrough", (event) => {
                    console.error("canplaythrough");
                });
                v.addEventListener("seeked", (event) => {
                    v.setAttribute("seeking_allowed", "yes");
                    console.error("seeked to", event.AT_TARGET, event.target, event.timeStamp);
                });
                v.addEventListener("seeking", (event) => {
                    v.setAttribute("seeking_allowed", "no");
                    console.error("seeking", Math.random());
                });
                document.getElementsByClassName("background")[0].appendChild(v);
                document.getElementById("video").appendChild(s);
                v.load();
            });
        } else {
            console.log('remove');
            removeVideo();
        }
    }, [handledUrl]);

    useEffect(() => {
        const node = document.getElementById("video");
        if (node) {
            if (isPaused && !node.paused) {
                node.pause();
            } else if (!isPaused && node.paused) {
                node.play();
            }
        }
    }, [isPaused]);


    return <SBackground className="background" hasVideo={hasVideo}>
        <AnimatePresence mode="sync">
            <motion.div id="background-content"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.6 }}
                        key={trackInfo.cover}
                        style={{backgroundImage: trackInfo.cover ? `linear-gradient(rgb(0 0 0 / 30%), rgb(0 0 0 / 30%)), url(${trackInfo.cover})` : "unset", filter: trackInfo.cover ? "blur(70px)" : "unset"}}
            >
            </motion.div>
        </AnimatePresence>

    </SBackground>
}
